import { createRouteRef, createPlugin, createComponentExtension } from '@backstage/core-plugin-api';

const entityContentRouteRef = createRouteRef({
  id: "security-insights"
});
const securityInsightsPlugin = createPlugin({
  id: "security-insights",
  routes: {
    entityContent: entityContentRouteRef
  }
});
const EntitySecurityInsightsContent = securityInsightsPlugin.provide(
  createComponentExtension({
    name: "EntitySecurityInsightsContent",
    component: {
      lazy: () => import('./components/SecurityInsightsTab/index.esm.js').then(
        (m) => m.SecurityInsightsTab
      )
    }
  })
);
const EntityGithubDependabotContent = securityInsightsPlugin.provide(
  createComponentExtension({
    name: "EntityGithubDependabotContent",
    component: {
      lazy: () => import('./components/GithubDependabotTab/index.esm.js').then(
        (m) => m.GithubDependabotTab
      )
    }
  })
);
const EntitySecurityInsightsCard = securityInsightsPlugin.provide(
  createComponentExtension({
    name: "EntitySecurityInsightsCard",
    component: {
      lazy: () => import('./components/SecurityInsightsWidget/index.esm.js').then(
        (m) => m.SecurityInsightsWidget
      )
    }
  })
);
const EntityDependabotAlertsCard = securityInsightsPlugin.provide(
  createComponentExtension({
    name: "EntityDependabotAlertsCard",
    component: {
      lazy: () => import('./components/DependabotAlertsWidget/index.esm.js').then(
        (m) => m.DependabotAlertsWidget
      )
    }
  })
);

export { EntityDependabotAlertsCard, EntityGithubDependabotContent, EntitySecurityInsightsCard, EntitySecurityInsightsContent, entityContentRouteRef, securityInsightsPlugin };
//# sourceMappingURL=plugin.esm.js.map
